export const APP_NAME = 'Kidon'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'

export enum Automation_Status {
    Initial = 'Initial',
    Editing = 'Editing',
    Inactive = 'Inactive',
    Active = 'Active',
    OnlyImport = 'Only Import',
    Hold = 'Hold',
}

export const statusOptions = [
    Automation_Status.Initial,
    Automation_Status.Editing,
    Automation_Status.Inactive,
    Automation_Status.Active,
    Automation_Status.OnlyImport,
    Automation_Status.Hold
].map((str) => ({ value: str, label: str }))


export enum Partner_Status {
    Active = 'Active',
    Inactive = 'Inactive',
    ManualImport = 'Manual Import',
    Initial = 'Initial'
}

export const partnerStatusOptions = [
    Partner_Status.Active,
    Partner_Status.Inactive,
    Partner_Status.ManualImport,
    Partner_Status.Initial
].map((str) => ({ value: str, label: str }))

export enum Domain_Status {
    Active = 'Active',
    Inactive = 'Inactive'
}

export const domainStatusOptions = [
    Domain_Status.Active,
    Domain_Status.Inactive
].map((str) => ({ id: str, title: str }))



export const dateFormatOptions = [
    { value: 'Auto', label: 'Auto' },
    { value: 'Unix', label: 'Unix' },
    { value: "YYYY-DD-MM", label: "YYYY-DD-MM" },
    { value: "YYYY-MM-DD", label: "YYYY-MM-DD" },
    { value: "DD-MM-YYYY", label: "DD-MM-YYYY" },
    { value: "MM-DD-YYYY", label: "MM-DD-YYYY" },
    { value: "D-M-YYYY", label: "D-M-YYYY" },
    { value: "DD/MM/YYYY", label: "DD/MM/YYYY" },
    { value: "DD/MM/YYYY HH:m", label: "DD/MM/YYYY HH:m" },
    { value: "YYYY-MM-DD HH:mm:ss.SSS", label: "YYYY-MM-DD HH:mm:ss.SSS"},
    { value: "MM/DD/YYYY HH:mm:ss", label: "MM/DD/YYYY HH:mm:ss"},
    { value: "M/D/YYYY h:mm A", label: "M/D/YYYY h:mm A" },
];
